<template>
  <div class="point-description">
    <div class="point-des" v-if="ruleDesc" v-html="ruleDesc"></div>
    <div v-else>
      <!-- 9.9.1 积分抵现：兜底文案修改 commoditySkuDiscount.commodityPoints.ruleDesc -->
      <div class="rule-title">使用条件：</div>
      <div class="rule">1、积分余额大于门槛积分（含）；</div>
      <div class="rule">2、当前等级为普通/白银/黄金的会员，最高使用积分抵现的金额分别为：</div>
      <div class="rule">配件-单笔订单实际应支付金额的10%/20%/30%；</div>
      <div class="rule">手机-单笔订单实际应支付金额的10%，不区分会员等级；</div>

      <div class="rule-title">使用说明：</div>
      <div class="rule">
        1、目前积分抵现仅限在售手机&配件的部分商品可用，当前商品是否支持请以页面标识为准；如遇活动或促销，请参考活动规则说明；
      </div>
      <div class="rule">2、抵现消耗的积分数量须为100的整数倍，如200/500/1000/10000等；</div>
      <div class="rule">3、按实际应支付金额计算，每100积分抵扣1元人民币；</div>
      <div class="rule">
        4、单笔订单内有多个可抵现商品时，抵扣部分按比例分摊；同时存在手机与配件时，将分别根据对应类别及规则进行抵现金额计算；
      </div>
      <div class="rule">5、积分抵现部分金额将无法开具发票；</div>
      <div class="rule">
        6、使用积分抵现的订单发生退货时，将按照实际退款金额对使用的积分做相应退回；退回后的积分有效期将按照使用前的有效期计算；
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PointDescription',
  props: {
    ruleDesc: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
